import React, { useState, useEffect } from 'react';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { app } from '../../firebase'; // Assuming your firebase.js exports 'app'

// Initialize Firebase Functions
const functionsInstance = getFunctions(app);
if (process.env.NODE_ENV === 'development') {
    try {
        connectFunctionsEmulator(functionsInstance, "127.0.0.1", 5001);
    } catch (error) {
        console.warn("Firebase Functions Emulator connection failed. This might be expected if the emulator is not running or if this is a production build.", error);
    }
}

const simPersonaCallable = httpsCallable(functionsInstance, 'simPersona');

const Twins = () => {
    const [formData, setFormData] = useState({
        promptCompany: '',
        promptRole: '',
        promptPitch: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [results, setResults] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setResults(null);

        try {
            const response = await simPersonaCallable(formData);
            setResults(response.data);
        } catch (err) {
            console.error("Error calling simPersona function:", err);
            setError(err.message || "An unexpected error occurred.");
        } finally {
            setLoading(false);
        }
    };

    const ShimmerPlaceholder = () => (
        <div className="space-y-6">
            <div className="h-8 bg-zinc-700 rounded animate-shimmer w-1/3"></div>
            <div className="space-y-3">
                <div className="h-4 bg-zinc-700 rounded animate-shimmer w-full"></div>
                <div className="h-4 bg-zinc-700 rounded animate-shimmer w-5/6"></div>
                <div className="h-4 bg-zinc-700 rounded animate-shimmer w-4/6"></div>
            </div>
            <div className="h-8 bg-zinc-700 rounded animate-shimmer w-1/4 mt-4"></div>
            <div className="space-y-3">
                <div className="h-4 bg-zinc-700 rounded animate-shimmer w-full"></div>
                <div className="h-4 bg-zinc-700 rounded animate-shimmer w-full"></div>
            </div>
        </div>
    );


    return (
        <div className="h-screen overflow-y-auto bg-zinc-900 text-zinc-100 p-4 md:p-8 flex flex-col items-center">
            <div className="w-full ">
                <h1 className="text-3xl md:text-4xl  text-sky-400 mb-8 text-center">Persona Pitch Analyzer</h1>

                <form onSubmit={handleSubmit} className="bg-zinc-800 p-6 md:p-8 rounded-lg   space-y-6">
                    <div>
                        <label htmlFor="promptCompany" className="block text-sm font-medium text-sky-300 mb-1">Company Name</label>
                        <input
                            type="text"
                            name="promptCompany"
                            id="promptCompany"
                            value={formData.promptCompany}
                            onChange={handleChange}
                            required
                            className="w-full bg-zinc-700 border border-zinc-600 text-zinc-100 rounded-md p-3 focus:ring-sky-500 focus:border-sky-500 placeholder-zinc-400"
                            placeholder="e.g., Acme Corp"
                        />
                    </div>
                    <div>
                        <label htmlFor="promptRole" className="block text-sm font-medium text-sky-300 mb-1">Target Role</label>
                        <input
                            type="text"
                            name="promptRole"
                            id="promptRole"
                            value={formData.promptRole}
                            onChange={handleChange}
                            required
                            className="w-full bg-zinc-700 border border-zinc-600 text-zinc-100 rounded-md p-3 focus:ring-sky-500 focus:border-sky-500 placeholder-zinc-400"
                            placeholder="e.g., Head of Marketing"
                        />
                    </div>
                    <div>
                        <label htmlFor="promptPitch" className="block text-sm font-medium text-sky-300 mb-1">Your Pitch</label>
                        <textarea
                            name="promptPitch"
                            id="promptPitch"
                            value={formData.promptPitch}
                            onChange={handleChange}
                            required
                            rows="6"
                            className="w-full bg-zinc-700 border border-zinc-600 text-zinc-100 rounded-md p-3 focus:ring-sky-500 focus:border-sky-500 placeholder-zinc-400 resize-none"
                            placeholder="Enter your sales pitch here..."
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-sky-500 hover:bg-sky-400 text-white font-semibold py-3 px-4 rounded-md transition duration-150 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                        {loading ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Analyzing...
                            </>
                        ) : (
                            'Analyze Pitch'
                        )}
                    </button>
                </form>

                {loading && (
                    <div className="mt-8 bg-zinc-800 p-6 md:p-8 rounded-lg shadow-2xl">
                        <ShimmerPlaceholder />
                    </div>
                )}

                {error && (
                    <div className="mt-8 bg-red-800/30 border border-red-700 p-4 rounded-md text-red-300">
                        <h3 className="font-semibold text-red-200">Error</h3>
                        <p>{error}</p>
                    </div>
                )}

                {results && !loading && (
                    <div className="mt-8   p-6 md:p-8 rounded-lg space-y-8">
                        <div>
                            <h2 className="text-2xl font-semibold text-sky-400 mb-4 border-b border-zinc-700 pb-2">Buyer Persona Used</h2>
                            <div className="space-y-3 text-sm md:text-base">
                                {Object.entries(results.buyerPersonaUsed).map(([key, value]) => (
                                    <div key={key} className="p-3 bg-zinc-700/50 rounded-md">
                                        <strong className="font-medium text-sky-300 capitalize block mb-1">{key.replace(/([A-Z])/g, ' $1').trim()}:</strong>
                                        <p className="text-zinc-300 whitespace-pre-wrap">{value}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h2 className="text-2xl font-semibold text-sky-400 mb-4 border-b border-zinc-700 pb-2">Pitch Analysis</h2>
                            <div className="space-y-4 text-sm md:text-base">
                                <div className="p-3   rounded-md">
                                    <strong className="font-medium text-sky-300 block mb-1">Overall Feedback:</strong>
                                    <p className="text-zinc-300 whitespace-pre-wrap">{results.pitchAnalysis.overallFeedback}</p>
                                </div>
                                <div className="p-3 bg-zinc-700/50 rounded-md">
                                    <strong className="font-medium text-sky-300 block mb-1">What They Liked:</strong>
                                    {results.pitchAnalysis.whatTheyLiked.length > 0 ? (
                                        <ul className="list-disc list-inside pl-4 text-zinc-300 space-y-1">
                                            {results.pitchAnalysis.whatTheyLiked.map((item, index) => <li key={index}>{item}</li>)}
                                        </ul>
                                    ) : <p className="text-zinc-400 italic">Nothing specific stood out positively.</p>}
                                </div>
                                <div className="p-3 bg-zinc-700/50 rounded-md">
                                    <strong className="font-medium text-sky-300 block mb-1">What They Did Not Like:</strong>
                                     {results.pitchAnalysis.whatTheyDidNotLike.length > 0 ? (
                                        <ul className="list-disc list-inside pl-4 text-zinc-300 space-y-1">
                                            {results.pitchAnalysis.whatTheyDidNotLike.map((item, index) => <li key={index}>{item}</li>)}
                                        </ul>
                                    ) : <p className="text-zinc-400 italic">No specific dislikes identified.</p>}
                                </div>
                                <div className="p-3 bg-zinc-700/50 rounded-md">
                                    <strong className="font-medium text-sky-300 block mb-1">What They Wish We Said:</strong>
                                     {results.pitchAnalysis.whatTheyWishWeSaid.length > 0 ? (
                                        <ul className="list-disc list-inside pl-4 text-zinc-300 space-y-1">
                                            {results.pitchAnalysis.whatTheyWishWeSaid.map((item, index) => <li key={index}>{item}</li>)}
                                        </ul>
                                    ) : <p className="text-zinc-400 italic">No specific omissions noted.</p>}
                                </div>
                                <div className="p-3 bg-zinc-700/50 rounded-md">
                                    <strong className="font-medium text-sky-300 block mb-1">How It Could Be More Precise:</strong>
                                    {results.pitchAnalysis.howItCouldBeMorePrecise.length > 0 ? (
                                        <ul className="list-disc list-inside pl-4 text-zinc-300 space-y-1">
                                            {results.pitchAnalysis.howItCouldBeMorePrecise.map((item, index) => <li key={index}>{item}</li>)}
                                        </ul>
                                    ) : <p className="text-zinc-400 italic">The pitch was considered sufficiently precise.</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Twins;

// Ensure you have the shimmer animation defined in your tailwind.config.js or global CSS:
// tailwind.config.js
/*
module.exports = {
  // ...
  theme: {
    extend: {
      animation: {
        shimmer: 'shimmer 1.5s infinite linear',
      },
      keyframes: {
        shimmer: {
          '0%': { backgroundPosition: '200% 0' },
          '100%': { backgroundPosition: '-200% 0' },
        },
      },
    },
  },
  // ...
};
*/

// Make sure your firebase.js (or equivalent) correctly initializes and exports 'app':
// Example: src/firebase.js
/*
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// import { getFunctions } from 'firebase/functions'; // Not needed here if app is passed

const firebaseConfig = {
  apiKey: "YOUR_API_KEY",
  authDomain: "YOUR_AUTH_DOMAIN",
  projectId: "YOUR_PROJECT_ID",
  storageBucket: "YOUR_STORAGE_BUCKET",
  messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
  appId: "YOUR_APP_ID",
  measurementId: "YOUR_MEASUREMENT_ID" // Optional
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app); // Optional
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
// const functions = getFunctions(app); // Already handled in Twins.jsx if app is passed

export { app, auth, db, storage };
*/
